import useCallApi from '../../../hooks/useCallApi'
import Loading from '../../../templates/UI/Loading/Loading'
import ReportTable from '../../../templates/ReportTable/ReportTable'
import Advertiser from '../../../templates/Advertiser/Advertiser'
import moment from 'moment'
import { Button } from 'reactstrap'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { Card, Modal } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import AdminPicker from '../../../components/AdminPicker/AdminPicker'
import Dollars from '../../../templates/Dollars/Dollars'
import AdvertiserRatePitchContent from '../../../components/AdvertiserRatePitchContent/AdvertiserRatePitchContent'

const RatePitchReport = ({ defaultAdminId }) => {
    const [adminId, setAdminId] = useState(defaultAdminId ? defaultAdminId : 0)
    const { data, dataLoaded, refetch } = useCallApi(`advertisers/ratePitchReport?adminId=${adminId}`, 'GET', {}, [adminId])
    const [workingId, setWorkingId] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const openModal = (e, id) => {
        e.preventDefault()
        setShowModal(true)
    }

    const closeModal = () => {
        setShowModal(false);
        refetch();
    }

    useEffect(() => {
        //update adminid in url
        const params = new URLSearchParams(window.location.search)
        if (adminId && adminId > 0) {
            params.set('adminId', adminId)
        } else {
            params.delete('adminId')
        }
        const newUrl = `${window.location.pathname}?${params.toString()}`
        window.history.replaceState({}, '', newUrl)
    }, [adminId])

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'Advertiser ID',
                accessor: 'advertiser.id',
            },
            {

                Header: 'Advertiser',
                accessor: 'advertiser.name',
                Cell: ({ cell: { value, row } }) => {
                    return (<Advertiser id={row.original.advertiser.id} name={value} />)
                }
            },
            {
                Header: 'Admin',
                accessor: 'admin.name',
            },
            {
                Header: 'Status Date',
                accessor: 'statusDate',
            },
            {
                Header: () => (
                    <div style={{ textAlign: 'right', width: '100%' }}>
                        Lifetime Margin
                    </div>
                ),
                accessor: 'lifetime_margin',
                Cell: ({ cell: { value } }) => {
                    return (
                        <div className="text-right">
                            <Dollars value={value ? value : 0} />
                        </div>
                    )
                }
            },
            {
                Header: 'Details',
                Cell: ({ cell: { value, row } }) => {
                    return (
                        <>
                            <Link to={`/advertisers/ratePitchCampaignReport/${row.original.id}`} className="b mr-2">
                                Breakdown
                            </Link>
                            <Link to={`/advertisers/ratePitch/${row.original.id}`} className="btn btn-warning btn-sm my-2" onClick={(e) => { setWorkingId(row.original.id); openModal(e, row.original.id) }}>View</Link>
                        </>
                    )
                }
            },
        ]

        return (
            <>
                <ReportTable data={data.pitches} columns={columns} />
                <Modal show={showModal} size="xl" onHide={() => setShowModal(false)}>
                    <AdvertiserRatePitchContent ratePitchId={workingId} refetch={refetch} closeModal={closeModal} />
                </Modal>
            </>
        )
    }

    return (
        <>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Rate Pitch Report</h1>

            </div>
            <Card>
                <Card.Header className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <h1 className="mb-h1-dark mr-2">Rate Pitches</h1>
                        <AdminPicker defaultSelf adminId={adminId} setAdminId={setAdminId} role={['ADOPS_MANAGER', 'ADOPS_TEAMLEAD', 'MERMGR']} required />
                    </div>
                </Card.Header>
                {dataLoaded ? data.pitches.length === 0 ? <div className="p-3">No rate pitches found.</div> : getReportOutput() : <Loading />}
            </Card>
        </>
    )
}

export default RatePitchReport